import { faWallet } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import ComingSoonPage from './ComingSoonPage'

export default function Earnings() {
    return (
        <div className='mt-5' data-aos='fade-in' data-aos-duration='1000'>
            <ComingSoonPage />
            <p className='text-xl font-medium tracking-widest uppercase'>Earnings</p>
            <div className='flex flex-col lg:flex-row mt-5 gap-5'>
                <div className='w-[100%] lg:w-[50%]'>
                    <div className='p-7 rounded-3xl bg-white/10'>
                        <p className='font-semibold text-lg'>TOTAL REVENUE</p>
                        <p className='mt-2 text-4xl lg:text-[65px] font-medium'>$753,000</p>
                        <div className='mt-5 flex flex-col lg:flex-row gap-5 items-center justify-around px-3 py-4 border rounded-2xl bg-white/5'>
                            <div className='flex items-center gap-3'>
                                <div className='w-7 h-7 bg-white rounded-xl grid place-content-center text-[#5C1FE2]'>
                                    <FontAwesomeIcon icon={faWallet} />
                                </div>
                                Update your Wallet
                            </div>
                            <button className='bg-[#5C1FE2] border rounded-2xl px-5 py-2'>View Transactions</button>
                        </div>
                    </div>
                    <div className='flex flex-col lg:flex-row items-center gap-5 mt-5 text-center'>
                        <div className='w-[100%] lg:w-[50%] p-5 rounded-3xl bg-white/10'>
                            <p className='font-semibold text-lg'>NFT SALES</p>
                            <p className='mt-2 text-2xl font-medium'>$110,890</p>
                        </div>
                        <div className='w-[100%] lg:w-[50%] p-5 rounded-3xl bg-white/10'>
                            <p className='font-semibold text-lg'>MERCHENDAISE</p>
                            <p className='mt-2 text-2xl font-medium'>$110,890</p>
                        </div>
                    </div>
                </div>
                <div className='w-[100%] lg:w-[50%]'>
                    <div className='lg:w-[75%] p-5 rounded-3xl bg-white/10'>
                        <div className='flex justify-between items-center'>
                            <p className='font-semibold text-lg'>NFT SALES</p>
                            <p className='font-semibold text-lg'>2025</p>
                        </div>
                        <div className='flex justify-between items-center'>
                            <p className='mt-3 text-3xl font-medium'>$110,890</p>
                            <p className='font-semibold text-lg'>APRIL</p>
                        </div>
                    </div>
                    <div className='mt-5 lg:w-[75%] p-5 rounded-3xl bg-white/10'>
                        <div className='flex justify-between items-center'>
                            <p className='font-semibold text-lg'>TRANSFER INCOME</p>
                            <p className='font-semibold text-lg'>2025</p>
                        </div>
                        <div className='flex justify-between items-center'>
                            <p className='mt-3 text-3xl font-medium'>$110,890</p>
                            <p className='font-semibold text-lg'>APRIL</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
